import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { API, Auth } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public isUserLoggedIn : any;
  
  constructor(
    private router: Router,
    private navController: NavController
  ) { }

  isLoggedIn() {
    return Auth.currentAuthenticatedUser();
    // console.log(localStorage.getItem("uid"), localStorage.length)
    // return localStorage.getItem('uid') != null && localStorage.getItem('uid') != undefined && localStorage.getItem('uid') != "null" && localStorage.getItem('uid') != "undefined";
  }

  logout() {
    const lang = localStorage.getItem('language');
    const version = localStorage.getItem('app_version');
    Auth.signOut({ global: true });
    localStorage.clear();
    localStorage.setItem('language', lang);
    localStorage.setItem('app_version', version);
    // this.router.navigateByUrl('/signup');
    // this.router.navigateByUrl('/signup', { replaceUrl: true, skipLocationChange: true })
    this.router.navigate(["/signup"], { replaceUrl: true });
  }

  getReq(apiName, path, myInit) {
    return API.get(apiName, path, myInit).then(data => {
      return data
    }).catch(err => {
      console.log("SAM: common error status: ",err?.response?.status)
      if (err?.response?.status == 403) {
        this.logout()
      } else {
        return err
      }
    })
  }
}
